import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';
import { SharedDataService } from '../shared-service/shared-data.service';

@Injectable({
  providedIn: 'root'
})
export class FarmoutService {

  constructor(private http: HttpClient, private sharedDataService: SharedDataService) { }

  fareEstimation(payload) {

    const url = urls.FARMOUT_BASE_URL + "trips/estimates";
    const hmac = this.sharedDataService.generateHmac(url, 'POST', payload);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });
    let options = { headers: authHeader };
    return this.http
      .post<any>(
        url,
        payload,
        options
      )
      .pipe(catchError(errorHandl));
  }

  rideRequest(payload) {
    const url = urls.FARMOUT_BASE_URL + "trips";
    const hmac = this.sharedDataService.generateHmac(url, 'POST', payload);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };
    return this.http
      .post<any>(
        url,
        payload,
        options
      )
      .pipe(catchError(errorHandl));
  }

  cancelRideRequest(requestId, payload) {
    const url = urls.FARMOUT_BASE_URL + "trips/cancel/" + requestId;
    const hmac = this.sharedDataService.generateHmac(url, 'POST', payload);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });
    let options = { headers: authHeader };

    return this.http
      .post<any>(
        url, payload,
        options
      )
      .pipe(catchError(errorHandl));
  }

  rideDetailsRequest(payload) {
    const url = urls.FARMOUT_BASE_URL + "trips/" + payload.requestId;
    const hmac = this.sharedDataService.generateHmac(url, 'POST', { company: payload.company, platform: payload.platform });

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };
    return this.http
      .post<any>(
        url, { company: payload.company, platform: payload.platform },
        options
      )
      .pipe(catchError(errorHandl));
  }

  rideUpdateRequest(requestId, payload) {
    const url = urls.FARMOUT_BASE_URL + "trips/" + requestId;
    const hmac = this.sharedDataService.generateHmac(url, 'PUT', payload);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };
    return this.http
      .put<any>(
        url, payload,
        options
      )
      .pipe(catchError(errorHandl));
  }

  rideReceiptRequest(requestId, payload) {
    const url = urls.FARMOUT_BASE_URL + "trips/receipt/" + requestId;
    const hmac = this.sharedDataService.generateHmac(url, 'POST', payload);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };
    return this.http
      .post<any>(
        url, payload,
        options
      )
      .pipe(catchError(errorHandl));
  }

  tipRequest(payload) {
    const url = urls.FARMOUT_BASE_URL + "trips/tip/" + payload.request_id;
    const hmac = this.sharedDataService.generateHmac(url, 'POST', payload);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };

    return this.http
      .post<any>(
        url,
        payload,
        options
      )
      .pipe(catchError(errorHandl));
  }


  getTrips(queryParams) {
    const url = urls.FARMOUT_BASE_URL + "trips/company/all?company=" + queryParams.company + "&date=" + queryParams.date;
    const hmac = this.sharedDataService.generateHmac(url, 'GET', null);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };
    return this.http.get<any>(url, options)
      .pipe(catchError(errorHandl));
  }

  getKPIDetails(queryParams) {
    const url = urls.FARMOUT_BASE_URL + "trips/dashboard2?company=" + queryParams.company + "&date=" + queryParams.date;
    const hmac = this.sharedDataService.generateHmac(url, 'GET', null);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };
    return this.http.get<any>(url, options)
      .pipe(catchError(errorHandl));
  }
  getReciptData(queryParams) {
    const url = urls.FARMOUT_BASE_URL + urls.GET_RECEIPTS + "?company=" + queryParams.company + "&date=" + queryParams.date;
    const hmac = this.sharedDataService.generateHmac(url, 'GET', null);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };

    return this.http.get(url, options)
      .pipe(catchError(errorHandl));
  }
  getReceiptStats(queryParams) {
    const url = urls.FARMOUT_BASE_URL + urls.GET_RECEIPTS_STATS + "?company=" + queryParams.company + "&date=" + queryParams.date;
    const hmac = this.sharedDataService.generateHmac(url, 'GET', null);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };

    return this.http.get(url, options)
      .pipe(catchError(errorHandl));
  }

  getAddress(queryParams) {
    const url = urls.FARMOUT_BASE_URL + "trips/autocomplete" + "?company=" + queryParams.company + "&locale=en" + "&query=" + queryParams.query;
    const hmac = this.sharedDataService.generateHmac(url, 'GET', null);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };

    return this.http.get(url, options)
      .pipe(catchError(errorHandl));
  }

  sendMessage(payload) {
    const { requestId, ...data } = payload
    const url = urls.FARMOUT_BASE_URL + "trips/message/" + requestId;
    const hmac = this.sharedDataService.generateHmac(url, 'POST', data);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });
    let options = { headers: authHeader };
    return this.http
      .post<any>(
        url,
        data,
        options
      )
      .pipe(catchError(errorHandl));
  }

  getMessages(tripId) {
   const url = urls.FARMOUT_BASE_URL + "trips/message/" +tripId ;
    const hmac = this.sharedDataService.generateHmac(url, 'GET', null);

    let authHeader = new HttpHeaders({
      "content-type": "application/json",
      "x-hmac": `HMAC ${hmac}`
    });

    let options = { headers: authHeader };

    return this.http.get<any>(url, options)
      .pipe(catchError(errorHandl));
  }

  getFarmoutSavings(queryParams?: any): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get<any>(urls.BASE_URL + urls.GET_FARMOUT_SAVINGS, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getFarmoutSavingStats(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_FARMOUT_SAVINGS_STATS, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveFarmoutSavings(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_FARMOUT_SAVINGS, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
}






